// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.106.2/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toast-icon{margin-right:1em}", "",{"version":3,"sources":["webpack://./../common/components/ToastNotification/styles.scss"],"names":[],"mappings":"AAAA,YAAA,gBAAA","sourcesContent":[".toast-icon{margin-right:1em}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
